module.exports = __webpack_public_path__ + "static/pic_service2-1505df1a493ef6d6ac449b0ddb38f0b2.jpg";